"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelLogin = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var userLogin_1 = require("../../model/userLogin");
var service_1 = require("../../../library/base/service");
var TelLogin = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(TelLogin, _super);
    function TelLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '短信验证码登录';
        _this.code = '101074';
        _this.desc = '';
        _this.requestParams = new userLogin_1.TelLoginRequest();
        // public responseParams: LoginResponse;
        _this.method = fetch_1.Methods.POST;
        _this.isSecurity = false;
        return _this;
    }
    return TelLogin;
}(service_1.BaseService));
exports.TelLogin = TelLogin;
//# sourceMappingURL=telLogin.js.map